import { CartUpsellingToolInput, LensPackage, Package } from "./types";

export function getInfo(
  suggestion: Package,
  input: {
    _content: CartUpsellingToolInput["_content"];
    _locale: CartUpsellingToolInput["_locale"];
    _packages: CartUpsellingToolInput["_packages"];
    _currentPackage: CartUpsellingToolInput["_currentPackage"];
    _imagery: CartUpsellingToolInput["_imagery"];
    _config?: CartUpsellingToolInput["_config"];
  },
  upsellKey: keyof LensPackage,
) {
  const key = upsellKey;
  const value = suggestion.lensPackage[key] as string;
  const content =
    typeof input._content?.[key] === "object" && input._content?.[key] !== null
      ? (input._content[key] as { [key: string]: any })[value]
      : {};
  return {
    key: key,
    value: value,
    content: {
      ...content,
      ...(content?.imageFileName1 && content?.imageFileName2
        ? {
            imageFileName1:
              input._config?.baseURLs?.assetsCDN +
              "/extra/image/rxc/icons/" +
              content.imageFileName1 +
              ".png",
            imageFileName2:
              input._config?.baseURLs?.assetsCDN +
              "/extra/image/rxc/icons/" +
              content.imageFileName2 +
              ".apng",
          }
        : content?.imageFileName
          ? {
              imageFileName:
                input._config?.baseURLs?.assetsCDN +
                "/extra/image/rxc/icons/" +
                content.imageFileName +
                ".png",
            }
          : {}),
    },
    listPrice: suggestion.lensPackage.listPrice,
    offerPrice: suggestion.lensPackage.offerPrice,
  };
}
